import { Injectable } from '@angular/core';
import { FullTextSummary, SearchOperators, FullTextSummaryHighlight, ValuesWithFullTextHighlight } from '../model/inventories';

@Injectable()
export class HighlightService {

  private numberCharactersSplitInSummaryText = 75;

  minLenghtInventory = 3;

  constructor() { }

  setHighlitghtsInHTML(innerHTML: string, keywords: string[]): string {
    const matches = [];
    let match: RegExpExecArray;
    let previousIndex = -1;

    const regexMatchAllTextInsideDivTag = '(s?)(?<=[^div]>).*?(?=<\\/)';
    const regex = new RegExp(regexMatchAllTextInsideDivTag, 'g');

    const regexMatchTextWithKeywords = this.getStringRegexByKeywords(keywords);
    const regexText = new RegExp(regexMatchTextWithKeywords, 'g');

    while ((match = regex.exec(innerHTML)) && previousIndex != match.index) {
      previousIndex = match.index;
      let matchText: RegExpExecArray;
      while ((matchText = regexText.exec(match[0].toLowerCase()))) {
        matches.push({ match: matchText[0], index: match.index + matchText.index });
      }
    }

    for (let i = matches.length - 1; i >= 0; i--) {
      innerHTML = this.hightlightTextWithStyleYellow(innerHTML, matches[i]);
    }

    return innerHTML;
  }

  setHighlitghtsInText(text: string, keywords: string[], isMultivalue: boolean): ValuesWithFullTextHighlight {
    keywords = keywords.filter(keyword => keyword.length > 3);
    const regexMatchTextWithKeywords = this.getStringRegexByKeywords(keywords);
    const regexText = new RegExp(regexMatchTextWithKeywords, 'g');
    const textLower = text.toLowerCase();
    const matches = [];

    let match: RegExpExecArray;

    while ((match = regexText.exec(textLower))) {
      matches.push({ match: match[0], index: match.index });
    }

    const firstFullTextHighlight: FullTextSummaryHighlight = new FullTextSummaryHighlight(text, false);

    let fulltextHighlight: FullTextSummaryHighlight[] = [firstFullTextHighlight];
    for (let i = matches.length - 1; i >= 0; i--) {
      fulltextHighlight = this.getFullTextSummaryHighlight(fulltextHighlight, matches[i]);
    }

    return new ValuesWithFullTextHighlight(fulltextHighlight, isMultivalue);
  }
  private getFullTextSummaryHighlight(fulltextHighlight: FullTextSummaryHighlight[], match: any): FullTextSummaryHighlight[] {
    const text = fulltextHighlight.shift().text;

    const textBefore = text.substring(0, match.index);
    const textHighligth = text.substr(match.index, match.match.length);
    const textAfter = text.substring(match.index + match.match.length);

    const newFulltextHighlight: FullTextSummaryHighlight[] = [];
    newFulltextHighlight.push(new FullTextSummaryHighlight(textBefore, false));
    newFulltextHighlight.push(new FullTextSummaryHighlight(textHighligth, true));
    newFulltextHighlight.push(new FullTextSummaryHighlight(textAfter, false));
    let order = 0;
    newFulltextHighlight.map(fulltext => fulltext.order = ++order);

    return [...newFulltextHighlight, ...fulltextHighlight];
  }

  private hightlightTextWithStyleYellow(text: string, match: any): string {
    const textBefore = text.substring(0, match.index);
    const textHighligth = text.substr(match.index, match.match.length);
    const textAfter = text.substring(match.index + match.match.length);
    const stringHighlight = '<span style="background-color:yellow">' + textHighligth + '</span>';
    text = textBefore + stringHighlight + textAfter;
    return text;
  }

  private getStringRegexByKeywords(keywords: string[]) {
    const keywordsLower = keywords.map(keyword => keyword.toLowerCase());
    const keywordLower = this.replaceWildCardsInRegex(keywordsLower.join('|'));
    return '(?=' + keywordLower + ')(' + keywordLower + ')';
  }

  getFirstOccurrenceHighligth(text: string, keywords: string[]): FullTextSummary {
    const keywordsLower = keywords.filter(k => k.length > this.minLenghtInventory).map(keyword => keyword.toLowerCase());
    const textLower = text.toLowerCase();

    let regex: RegExpExecArray;

    const keywordLower = keywordsLower.find(keywordLow => {
      regex = this.getRegex(textLower, keywordLow);
      return (regex && regex.index != -1);
    });

    return keywordLower ? this.getFullTextSummaryObject(regex[0], text, regex.index)
      : null;
  }

  getFirstOccurrenceInListTextHighligth(texts: string[], keywords: string[], operador: SearchOperators): FullTextSummary {
    const keywordsLower = this.getKeywordsLower(keywords, operador);

    const firstFullTextCoincidence = texts
      .find(text => this.containsKeywordsWithWildcard(text.toLowerCase(), keywordsLower));

    if (firstFullTextCoincidence) {
      for (const keywordLower of keywordsLower) {
        const regexWord = this.getRegex(firstFullTextCoincidence.toLowerCase(), keywordLower);

        if (regexWord && regexWord.index != -1) {
          return this.getFullTextSummaryObject(regexWord[0], firstFullTextCoincidence, regexWord.index);
        }
      }
     }

    return null;
  }

  private getKeywordsLower(keywords: string[], operator: SearchOperators): string[] {
    if (operator == SearchOperators.OR) {
      return keywords.map(keyword => keyword.replace(/"/g, '').replace(/'/g, '')
                        .split(' ')).reduce((a, b) => a.concat(b)).map(keyword => keyword.trim());
    }

    return [keywords.join(' ')];
  }


  private containsKeywordsWithWildcard(fullTextLower: string, keywordsLower: string[]): boolean {
    return keywordsLower.some(keywordLower => !!this.getRegex(fullTextLower, keywordLower));
  }

  private getRegex(fullTextLower: string, keywordLower: string): RegExpExecArray {
    const regexString = this.replaceWildCardsInRegex(keywordLower);
    const regex = new RegExp(regexString);

    return regex.exec(fullTextLower);
  }

  private replaceWildCardsInRegex(keyword: string): string {
    const regexInterrogativeReplace = keyword.split('?').join('(.)');
    return regexInterrogativeReplace.split('*').join('(.+?)');
  }

  private getFullTextSummaryObject(keywordLower: string, textComplete: string, indexSearch: number): FullTextSummary {
    const fullTextSummary = new FullTextSummary();
    let firstIndex = indexSearch <= this.numberCharactersSplitInSummaryText ? 0
      : indexSearch - this.numberCharactersSplitInSummaryText;
    const textEnd = indexSearch + keywordLower.length + this.numberCharactersSplitInSummaryText;
    let lastIndex = textEnd >= textComplete.length ? textComplete.length
      : textEnd;

    let beginWith = '', finishWith = '';

    if (firstIndex != 0) {
      const firstIndexOfWord = textComplete.substring(0, firstIndex).lastIndexOf(' ');
      if (firstIndexOfWord != -1) {
        firstIndex = firstIndexOfWord;
      }
      beginWith = '...';
    }

    if (lastIndex != textComplete.length) {
      const lastIndexOfWord = textComplete.substring(lastIndex).indexOf(' ');
      if (lastIndexOfWord != -1) {
        lastIndex += lastIndexOfWord + 1;
      }

      finishWith = '...';
    }

    fullTextSummary.textBefore = beginWith + textComplete.substring(firstIndex, indexSearch);
    fullTextSummary.textAfter = textComplete.substring(indexSearch + keywordLower.length, lastIndex) + finishWith;
    fullTextSummary.textHighlightSearch = textComplete.substring(indexSearch, indexSearch + keywordLower.length);

    return fullTextSummary;
  }

}
